/* eslint-disable react/jsx-pascal-case */

import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { NextButton, SecondChoiseButton } from "../components/styled/Button.style";
import { Section } from "../components/styled/Containers.style";
import { Vspace } from "../components/styled/Separators.style";
import { PageTitle, TextDefault } from "../components/styled/Text.style";
import Trtc_ZoneUrtoCmp from "../components/zone-urto-trtc/Trtc_ZoneUrtoCmp";
import { PATHS } from "../routes/CaiExperienceRouter";
import { selectCommunicationData } from "../store";
import { saveCommunicationAct } from "../store/communication-data/actions";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { BaremeUserChoiseEnum, CommunicationType, ZoneUrtoType } from "../types/communication/communicationDataType";
import { composeUrl } from "../utils/utils";
import PageContainerCmp from "./PageContainerCmp";

/* istanbul ignore next */
const Trct_ZoneUrtoVeicoloPage = (props: any) => {

    const { isMainImpactPoint } = props;
    const dispatch = useAppDispatch();
    let navigate = useNavigate();
    let { token } = useParams();

    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const [zoneUrto, setZoneUrto] = useState<ZoneUrtoType[]>([])
    const zoneUrtoValid = useMemo(() => zoneUrto.length > 0, [zoneUrto.length])
    const nextBtnDisabled = !zoneUrtoValid;

    useEffect(() => {
        const initialZones = initializeZoneUrto();
        setZoneUrto(initialZones);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMainImpactPoint, communication]);

    // Configurazione della pagina basata sul tipo di selezione
    const pageConfig = useMemo(() => {
        const configs = {
            mainImpact: {
                routePath: PATHS.TRCT_MAIN_ZONE_URTO_VEICOLO,
                nextStepPath: PATHS.TRCT_ZONE_URTO_VEICOLO,
                title: "Seleziona il punto d'impatto principale sul tuo veicolo",
                description: "Cliccando sui bottoni puoi aggiungere/rimuovere il punto d'impatto principale. L'eventuale area già evidenziata è stata rilevata dalla black box."
            },
            additionalZones: {
                routePath: PATHS.TRCT_ZONE_URTO_VEICOLO,
                nextStepPath: PATHS.TRCT_CTP_MAIN_ZONE_URTO_VEICOLO,
                title: "Aggiungi ulteriori zone danneggiate durante l'impatto",
                description: "Cliccando sui bottoni puoi aggiungere/rimuovere zone di urto."
            }
        };
        return isMainImpactPoint ? configs.mainImpact : configs.additionalZones;
    }, [isMainImpactPoint]);

    // Inizializzazione delle zone d'urto
    const initializeZoneUrto = () => {
        if (isMainImpactPoint === undefined) return [];
        if (isMainImpactPoint) {
            // Pagina del punto principale: cerca il mainImpactPoint del cliente, oppure il main_impact_point della box
            const impactPosition = communication.mainImpactPoint || communication.main_impact_point;
            return impactPosition ? [new ZoneUrtoType({ position: impactPosition, isSelected: true })] : [];
        } else {
            // Pagina delle zone aggiuntive: usa le zone esistenti
            return communication.zoneUrto || [];
        }
    };

    const getBackPath = () => {
        // Se siamo nella pagina secondaria (zone aggiuntive), torna sempre alla pagina principale
        if (!isMainImpactPoint) {
            return PATHS.TRCT_MAIN_ZONE_URTO_VEICOLO;
        }

        // Se siamo nella pagina principale, usa la logica basata sul bareme
        const { baremeUserChoise } = communication;

        switch (baremeUserChoise) {
            case BaremeUserChoiseEnum.BAREME_BATCH_ACCEPTED:
                return PATHS.BACH_BAREME_DYNAMIC;
            case BaremeUserChoiseEnum.BAREME_QUESTIONS_FILLED_ACCEPTED:
                return PATHS.BAREME_Q_DYNAMIC;
            default:
                return PATHS.FREE_INCIDENT_DESCRIPTION;
        }
    };

    const goToNextStepHandler = () => {
        dispatch(saveCommunicationAct({
            data: new CommunicationType({
                ...communication,
                zoneUrto: isMainImpactPoint ? communication.zoneUrto.filter(el => el.position !== communication.mainImpactPoint) : zoneUrto,
                mainImpactPoint: isMainImpactPoint ? zoneUrto[0].position : communication.mainImpactPoint
            }),
            callback: () => navigate(composeUrl(token, pageConfig.nextStepPath))
        }));
    };

    const noZoneUrtoHandler = () => {
        dispatch(saveCommunicationAct({
            data: new CommunicationType({
                ...communication,
                zoneUrto: []
            }),
            callback: () => navigate(composeUrl(token, pageConfig.nextStepPath))
        }));
    }

    return (
        <>
            <PageContainerCmp
                routePath={pageConfig.routePath}
                removeNextBtn
                backPath={getBackPath()}
            >
                <>
                    <Section>
                        <PageTitle>{pageConfig.title}</PageTitle>
                        <Vspace></Vspace>
                        <TextDefault centered>{pageConfig.description}</TextDefault>
                    </Section>

                    <Section>
                        <Trtc_ZoneUrtoCmp
                            mainImpactPoint={communication.mainImpactPoint}
                            isMainImpactPoint={isMainImpactPoint}
                            zoneUrto={zoneUrto}
                            setZoneUrto={setZoneUrto}
                        />
                    </Section>

                    <NextButton style={{ textTransform: "none", margin: "0 2.5rem" }} disabled={nextBtnDisabled} onClick={goToNextStepHandler}>{isMainImpactPoint ? "Conferma punto d'impatto" : "Conferma zone d'urto"}</NextButton>
                    <Vspace qty={2}></Vspace>
                    {!isMainImpactPoint && <SecondChoiseButton disabled={zoneUrto.length > 0} style={{ fontSize: "16px", color: "#0F3250" }} onClick={noZoneUrtoHandler}>Non ci sono altre zone d'urto</SecondChoiseButton>}
                </>
            </PageContainerCmp>

        </>
    )
}

export default Trct_ZoneUrtoVeicoloPage